<template>
  <div class>
    <h1>About Page</h1>
    <p>First Name: {{ this.$route.query.firstname }}</p>
    <p>Email: {{ this.$route.query.email }}</p>
  </div>
</template>

<script>
export default {
  name: "About"
};
</script>